const links = {
  pypi: "https://pypi.org/project/prometheus-ebm/",
  github_sdk: "https://github.com/Mushfiqul-Alam-17/prometheus-ebm-sdk.git",
  github_profile: "https://github.com/Mushfiqul-Alam-17",
  kaggle_dataset: "https://www.kaggle.com/datasets/mushfiqulalam007/kaggle-agi-bm",
  kaggle_writeup:
    "https://www.kaggle.com/competitions/kaggle-measuring-agi/writeups/prometheus-ebm-measuring-what-frontier-ai-models",
  kaggle_notebook:
    "https://www.kaggle.com/code/mushfiqulalam007/prometheus-ebm-epistemic-metacognition-benchmark",
  linkedin: "https://www.linkedin.com/in/mushfiqul-alam-17-/",
};

export default links;
